import { gql } from "@apollo/client";



export const OBTENER_FILTROS_USUARIOS = gql`
  query FiltrosUsuarios($tipo: String!) {
    actividades {
      obtenerFiltrosUsuarios(tipo: $tipo) {
        roles {
          id
          nombre
        }
        usuarios {
          id
          rolId
          persona {
            nombre
            apellidoPaterno
            apellidoMaterno
            correoInstitucional
          }
        }
      }
    }
  }
`;

export const OBTENER_FILTROS_PROSPECTOS = gql`
  query FiltrosProspectos($id: ID) {
    actividades {
      obtenerFiltrosProspectos(id: $id) {
        eventos {
          id
          nombre
        }
        prospectos {
          id
          nombre
          apellidos
          correo
          ocupacion
          zona
          estado
          eventoId
          municipio
          listaCultivos {
            cultivo {
              id
              nombre
            }
          }
          cultivoTipo
          calificacion
          universidad
          atendidoPorId
        }
        universidades
        estadosMunicipios
        cultivos {
          id
          nombre
        }
      }
    }
  }
`;

export const OBTENER_FILTROS_CONTACTOS = gql`
  query FiltrosContactos($id: ID) {
    actividades {
      obtenerFiltrosContactos(id: $id) {
        contactos {
          id
          nombre
          apellidos
          correo
          prospectoId
          prospecto {
            atendidoPorId
          }
          listaPuestos {
            puesto {
              nombre
            }
          }
        }
        puestos
        prospectos {
          id
          nombre
          apellidos
        }
      }
    }
  }
`;

export const OBTENER_FILTROS_PROSPECTOS_USUARIOS = gql`
  query FiltrosProspectosUsuarios {
    actividades {
      obtenerFiltrosProspectosUsuarios {
        usuarios {
          id
          persona {
            nombre
            apellidoPaterno
            apellidoMaterno
          }
        }
        prospectos {
          id
          nombre
          apellidos
          atendidoPorId
        }
      }
    }
  }
`;

export const OBTENER_IMAGENES_POR_ACTIVIDAD = gql`
  query ($actividadId: ID!) {
    actividades {
      obtenerImagenesDeActividadAsync(actividadId: $actividadId) {
        id
        isTratamiento
        isTestigo
        comentario
        documento {
          id
          url
        }
      }
    }
  }
`;

export const OBTENER_ACTIVIDADES_POR_USUARIO = gql`
  query listaActividades(
    $usuarioId: ID!
    $estatus: EstatusActividadEnum
    $fechaInicio: Date
    $fechaFin: Date
    $prospectoId: ID
  ) {
    actividades {
      obtenerActividadesPorUsuario(
        usuarioId: $usuarioId
        estatus: $estatus
        fechaInicio: $fechaInicio
        fechaFin: $fechaFin
        prospectoId: $prospectoId
      ) {
        actId
        fechaCreacion
        fechaHora
        fechaHoraFin
        idAsignado
        nombreAsignado
        nombreTitulo
        infoAsignado
        estatusActividad
        tipoActividad
        tipoRegistro
        esEvento
        asunto
      }
    }
  }
`;

export const OBTENER_ACTIVIDAD_POR_ID = gql`
  query ($id: ID!) {
    actividades {
      obtenerActividadPorId(id: $id) {
        id
        activo
        estatusActividad
        fechaCreacion
        eventosIds
        tipoActividad
        asunto
        asignadosJSON
        cc
        cco
        descripcion
        eventosIds
        fechaHora
        fechaHoraFin
        hipervinculo
        invitadosIds
        desarrolloId
        para
        recordatorios
        tipoActividad
        tipoRegistro
        esEvento
        actividadDocumentos {
          id
          fechaCreacion
          actividadId
          documento {
            key
            contentType
            nombreArchivo
            url
          }
        }
      }
    }
  }
`;



export const OBTENER_PAGINADO_ACTIVIDADES_CATALOGO = gql`
  query listaActividades(
    $query: QueryInput!
    $usuarioId: ID!
    $fechaInicio: Date
    $fechaFin: Date
  ) {
    actividades {
      paginadoActividadesCatalogo(
        query: $query
        usuarioId: $usuarioId
        fechaInicio: $fechaInicio
        fechaFin: $fechaFin
      ) {
        totalItems
        items {
          id  
          actId
          fechaActualizacion
          fechaHora
          fechaHoraFin
          idAsignado
          nombreAsignado
          nombreTitulo
          estatusActividad
          tipoActividad
          observacion
          tipoRegistro
          asunto
          descripcion
          hipervinculo
          esEvento
          actividadDocumentos {
            id
            fechaCreacion
            actividadId
            documento {
              key
              contentType
              nombreArchivo
              url
            }
          }
        }
      }
    }
  }
`;




export const OBTENER_PAGINADO_ACTIVIDADES = gql`
  query listaActividades(
    $pagina: Int!
    $tamano: Int!
    $tipoActividad: TipoActivivdadEnum
    $usuarioId: ID!
    $estatus: EstatusActividadEnum
    $fechaInicio: Date
    $fechaFin: Date
    $prospectoId: ID
  ) {
    actividades {
      paginadoActividades(
        pagina: $pagina
        tamano: $tamano
        tipoActividad: $tipoActividad
        usuarioId: $usuarioId
        estatus: $estatus
        fechaInicio: $fechaInicio
        fechaFin: $fechaFin
        prospectoId: $prospectoId
      ) {
        totalItems
        items {
          actId
          fechaActualizacion
          fechaHora
          fechaHoraFin
          idAsignado
          nombreAsignado
          nombreTitulo
          estatusActividad
          tipoActividad
          observacion
          tipoRegistro
          asunto
          descripcion
          hipervinculo
          esEvento
          actividadDocumentos {
            id
            fechaCreacion
            actividadId
            documento {
              key
              contentType
              nombreArchivo
              url
            }
          }
        }
      }
    }
  }
`;
